'use client';

import { motion } from 'framer-motion';
import { Home, ArrowLeft, AlertTriangle } from 'lucide-react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className='min-h-screen bg-background'>
      <section className='relative overflow-hidden bg-white pt-20 pb-16 sm:pt-24 sm:pb-20'>
        <div className='relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          <div className='text-center max-w-4xl mx-auto'>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className='flex justify-center mb-8'>
                <div className='p-4 bg-red-100 rounded-lg'>
                  <AlertTriangle className='h-8 w-8 text-red-600' />
                </div>
              </div>

              <h1 className='text-5xl md:text-6xl font-bold text-foreground mb-8 leading-tight tracking-tight'>
                404
                <br />
                <span className='text-primary'>Page Not Found</span>
              </h1>

              <p className='text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed font-light mb-8'>
                The page you're looking for doesn't exist or has been moved.
                Let's get you back on track to managing your treasury
                operations.
              </p>

              <div className='flex flex-col sm:flex-row gap-4 justify-center items-center'>
                <Button asChild size='lg' className='w-full sm:w-auto'>
                  <Link href='/'>
                    <Home className='h-4 w-4 mr-2' />
                    Go Home
                  </Link>
                </Button>
                <Button
                  variant='outline'
                  size='lg'
                  className='w-full sm:w-auto'
                  onClick={() => window.history.back()}
                >
                  <ArrowLeft className='h-4 w-4 mr-2' />
                  Go Back
                </Button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
